import { render } from "./MenuItemCard.vue?vue&type=template&id=f4c514bc&scoped=true"
import script from "./MenuItemCard.vue?vue&type=script&lang=js"
export * from "./MenuItemCard.vue?vue&type=script&lang=js"

import "./MenuItemCard.vue?vue&type=style&index=0&id=f4c514bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4c514bc"

export default script